import React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ExperimentPageProvider } from '../context';
import { useQueryExperiment } from '../hooks/query-experiment';
import { NEW_EXPERIMENT_ID } from '../utils';
import { ExperimentPageContent } from './_content';
import { ExperimentPageNewExperiment } from './new-experiment';
type ExperimentPageProps = {
  projectId: number;
  workspaceId: number;
  userId: number;
  experimentId: string;
  featureFlagIntegrationEnabled: boolean;
};
export function ExperimentPage(_ref: ExperimentPageProps) {
  let {
    projectId,
    workspaceId,
    userId,
    experimentId,
    featureFlagIntegrationEnabled
  }: ExperimentPageProps = _ref;
  const experiment = useExperimentsStore(state => state.experiment);
  const experimentLoading = useExperimentsStore(state => state.experimentLoading);
  useQueryExperiment({
    projectId,
    workspaceId,
    experimentId,
    featureFlagIntegrationEnabled
  });
  if (!experiment || experimentLoading) {
    return <SpinnerReact size={SpinnerSize.Large} />;
  }
  return <ExperimentPageProvider projectId={projectId} workspaceId={workspaceId} experimentId={experimentId} userId={userId} featureFlagIntegrationEnabled={featureFlagIntegrationEnabled} data-sentry-element="ExperimentPageProvider" data-sentry-component="ExperimentPage" data-sentry-source-file="index.tsx">
      <ExperimentPageContent data-sentry-element="ExperimentPageContent" data-sentry-source-file="index.tsx" />
      {(experiment === null || experiment === void 0 ? void 0 : experiment.id) === NEW_EXPERIMENT_ID && <ExperimentPageNewExperiment />}
    </ExperimentPageProvider>;
}